// src/pages/SettingsPage.jsx
import React, { useMemo, useState } from "react";
import BasicDetailsSection from "./sections/BasicDetailsSection";
import CreativeProfileSection from "./sections/CreativeProfileSection";
import BillingSection from "./sections/BillingSection";
import FunFactsSection from "./sections/FunFactsSection";
import FikaUpdatesSection from "./sections/FikaUpdatesSection";
import { useAuthBootstrap } from "../../context/AuthBootstrapContext";

import SettingsShell from "./SettingsShell";
import RewardsPage from "./sections/Rewards";


export default function SettingsPage() {
  const { person } = useAuthBootstrap();
  const isNYC = (person?.city || "").toLowerCase().includes("new york");

  // Scalable: add a new tab by adding an entry here
  const tabs = useMemo(
    () => [
      {
        id: "basic",
        title: "Basic Details",
        Component: BasicDetailsSection,
      },
      {
        id: "creative",
        title: "Creative Profile",
        Component: CreativeProfileSection,
      },
      {
        id: "billing",
        title: "Billing",
        Component: BillingSection,
      },
      ...(!isNYC ? [{
        id: "rewards",
        title: "Rewards",
        Component: RewardsPage,
      }] : []),
      {
        id: "fika-updates",
        title: "Fika Preferences",
        Component: FikaUpdatesSection,
      },
      {
        id: "fun-facts",
        title: "Fun Facts",
        Component: FunFactsSection,
      },
    ],
    [isNYC]
  );

  const [activeTabId, setActiveTabId] = useState(tabs[0].id);
  const activeTab = tabs.find((t) => t.id === activeTabId) ?? tabs[0];

  return (
    <SettingsShell
      tabs={tabs}
      activeTabId={activeTabId}
      onTabChange={setActiveTabId}
      RightComponent={activeTab.Component}
      rightTitle={activeTab.title}
    />
  );
}